export default "__VITE_ASSET__c220608e__"